import React from 'react';
import Link from 'components/UI/Link';
import SocialMediaIcon from './SocialMedia/SocialMediaIcon';
import { useTrans, useLang, useLocalisedPrivacyLinks } from 'utils/localisation';
import * as styles from './Copyright.module.scss';

function Copyright() {
  const lang = useLang();
  const t = useTrans(['copyright']);
  const currentYear = new Date().getFullYear();

  const { privacyPolicyLink, cookiesPolicyLink } = useLocalisedPrivacyLinks();

  const firstParagraph =
    lang === 'ae'
      ? `${t('allRightsReserved')} © ${currentYear} ${t('companyName')} `
      : `© ${currentYear} ${t('companyName')} ${t('allRightsReserved')}. `;

  return (
    <div className={styles.wrapper}>
      <div className={styles.layout}>
        <div className={styles.copyright}>
          <div className={styles.textSection}>
            <p className={styles.text}>
              {firstParagraph}
              <Link
                className={styles.link}
                href={privacyPolicyLink}
                target="_blank"
                rel="noreferrer noopener"
              >
                {t('privacyPolicy')}
              </Link>
              {` ${t('captcha').and} `}
              <Link
                className={styles.link}
                href={cookiesPolicyLink}
                target="_blank"
                rel="noreferrer noopener"
              >
                {t('cookiesPolicy')}.
              </Link>
            </p>
            <p className={styles.text}>
              {t('captcha').intro}{' '}
              <Link
                className={styles.link}
                href="https://policies.google.com/privacy"
                rel="noreferrer noopener"
              >
                {t('captcha').privacyPolicy}
              </Link>
              {` ${t('captcha').and} `}
              <Link
                className={styles.link}
                href="https://policies.google.com/terms"
                rel="noreferrer noopener"
              >
                {t('captcha').termsOfService}
              </Link>{' '}
              {t('captcha').end}.
            </p>
            {lang === 'de' && (
              <p className={styles.text}>
                <Link
                  className={styles.link}
                  href="/impressum"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Impressum
                </Link>
              </p>
            )}
          </div>
          <div className={styles.socialSection}>
            <SocialMediaIcon />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Copyright;
